import { render } from "./GameStart.vue?vue&type=template&id=3ea231e4"
import script from "./GameStart.vue?vue&type=script&lang=js"
export * from "./GameStart.vue?vue&type=script&lang=js"

import "./GameStart.vue?vue&type=style&index=0&id=3ea231e4&lang=scss"
script.render = render

export default script